import React from "react";

export default function JogiNyilatkozat() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-[#161616] backdrop-blur-xl rounded-2xl shadow-2xl border border-white/[0.08] overflow-hidden">
          <div className="p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-white mb-4">📄 Jogi nyilatkozat</h1>
              <div className="w-24 h-1 bg-gradient-to-r from-[#e31937] to-[#b40000] mx-auto rounded-full"></div>
            </div>

            <div className="space-y-6 text-gray-300 leading-relaxed">
              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <h2 className="text-xl font-bold text-white mb-4">Általános tájékoztatás</h2>
                <p className="mb-4">
                  A <span className="font-semibold text-white">HoppX</span>, <span className="font-semibold text-white">HoppHomes</span> és <span className="font-semibold text-white">HoppCars</span> weboldalak tartalma kizárólag tájékoztató jellegű.
                </p>
                <p>
                  Az üzemeltető törekszik arra, hogy a közzétett információk pontosak és naprakészek legyenek, azonban az esetleges hibákért vagy elírásokért felelősséget nem vállal.
                </p>
              </div>

              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <h2 className="text-xl font-bold text-white mb-4">Szolgáltatások elérhetősége</h2>
                <p className="mb-4">
                  Az oldalak minden felhasználó számára elérhetőek és működnek. Azon funkciók, amelyek tesztelés vagy fejlesztés alatt állnak, külön jelölve vannak, így a felhasználókat semmilyen módon nem éri megtévesztés.
                </p>
                <p>
                  A szolgáltatások egy része díjmentesen igénybe vehető (pl. autóhirdetés feltöltése), további részletek és feltételek a weboldalakon találhatók.
                </p>
              </div>

              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <h2 className="text-xl font-bold text-white mb-4">Módosítások joga</h2>
                <p>
                  Az üzemeltető fenntartja a jogot a szolgáltatások és tartalmak előzetes értesítés nélküli módosítására.
                </p>
              </div>

              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-6">
                <div className="flex items-start space-x-3">
                  <div className="text-yellow-400 text-xl">⚠️</div>
                  <div>
                    <h3 className="text-yellow-300 font-semibold mb-2">Fontos figyelmeztetés</h3>
                    <p className="text-yellow-200 text-sm">
                      A weboldalon található információk nem helyettesítik a szakmai tanácsadást. Kérjük, minden döntés előtt konzultáljon szakértővel.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <a 
                href="/"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#e31937] to-[#b40000] hover:from-[#b40000] hover:to-[#8b0000] text-white font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Vissza a főoldalra
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
